module.exports = __webpack_public_path__ + "media/images/athletes/3518-15d2a03afe5e3984cdc368b0bfe59e90.png";